
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.8.7c.4-.4 1-.5 1.5-.1.4.4.5 1 .1 1.5L4.8 7.4c-.4.4-1 .5-1.4.1L.8 5.4C.3 5 .2 4.4.5 3.9s1-.6 1.5-.2l.1.1 1.7 1.4 4-4.5z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#002823"}})])
          )
        }
      }
    